import React, { useEffect } from 'react'
import { RHFInput } from 'react-hook-form-input'
import { useForm } from 'react-hook-form'

import { Grid, TextField, Typography } from '@material-ui/core'

import { Label } from 'components'

import useConsent from 'hooks/useConsent'
import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import schema from './schema'
import constants from 'constants/index'

const GeneralInformation = () => {
  const {
    nextStep,
    toNextStep,
    setToNextStep,
    setDataConsentForm,
    dataConsentForm,
    setIsConsentLoading,
  } = useConsent()

  const snackbar = useSnackbar()

  const { register, setValue, handleSubmit, errors } = useForm({
    validationSchema: schema,
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      title: dataConsentForm?.title ?? '',
      subtitle: dataConsentForm?.subtitle ?? '',
      legalFrameworkId: dataConsentForm?.legalFrameworkId?.toString() ?? '',
    },
  })

  useEffect(() => {
    if (toNextStep) {
      handleSubmit(onSubmit)()

      if (errors) setToNextStep(false)
    }
    // eslint-disable-next-line
  }, [toNextStep])

  const onSubmit = async (data) => {
    setIsConsentLoading(true)

    try {
      setDataConsentForm((oldData) => ({
        ...oldData,
        ...data,
        legalFrameworkId: constants.consent.LEGAL_BASIS_CONSENT_ID,
      }))

      nextStep()
      setToNextStep(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setIsConsentLoading(false)
    }
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      id={constants.consent.NEW_CONSENT_FORM_DRIVER_STEP_0}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="caption" color="textSecondary">
            Preencha os campos de informações gerais do formulário de
            consentimento
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Label title="Título do formulário" item xs={12}>
              <RHFInput
                as={
                  <TextField
                    error={!!errors.title}
                    helperText={errors?.title?.message}
                    label="Insira o título do formulário"
                    fullWidth
                  />
                }
                register={register}
                setValue={setValue}
                name="title"
                mode="onChange"
              />
            </Label>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Label title="Subtítulo" item xs={12}>
              <RHFInput
                as={
                  <TextField
                    error={!!errors.subtitle}
                    helperText={errors?.subtitle?.message}
                    label="Descreva um subtítulo para o formulário"
                    fullWidth
                  />
                }
                register={register}
                setValue={setValue}
                name="subtitle"
                mode="onChange"
              />
            </Label>
          </Grid>
        </Grid>
      </Grid>
    </form>
  )
}

export default GeneralInformation
